<template>
	<el-container>
		<el-header class="nav-container" style="height: auto !important;">
			<navbar 
				:nav-index="6" 
				@nav-items-click="navClick" 
				@pop-click="popClick" />
		</el-header>
		<el-container>
			<el-aside 
				width="auto" 
				class="aside-container">
				<sidebar 
					:items="routerItems" 
					main-router="setting">
				</sidebar>
			</el-aside>
			<el-main id="crm-main-container">
				<app-main />
			</el-main>
		</el-container>
		<edit-password 
			:show="showEditPassword" 
			@close="showEditPassword=false" />
	</el-container>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		Navbar,
		Sidebar,
		AppMain
	} from './components'
	import EditPassword from './components/EditPassword'
	import { managerRouterMenu } from '@/router/modules/setting'

	export default {
		name: 'Layout',
		components: {
			Navbar,
			Sidebar,
			AppMain,
			EditPassword
		},

		data() {
			return {
				isCreate: false,
				createCRMType: '',
				showEditPassword: false,
				routerItems: []
			}
		},
		computed: {
			...mapGetters(['setting', 'allAuth']),

		},
		created() {
			// this.getcrmMessagNum()
			// this.getcrmSettingConfig()
			// console.log(this.settingRouters);
		},

		mounted() {
			this.routerItems = this.filterAsyncRouter(managerRouterMenu, this.allAuth)
			// this.getAuthMenu()
		},

		methods: {
			navClick(index) {},
			popClick() {
				this.showEditPassword = true
			},
			
			filterAsyncRouter(routers, authInfo) {
				const res = []
				routers.forEach(router => {
					const tmp = {
						...router
					}
					if (this.checkAuth(tmp, authInfo)) {
						if (tmp.children) {
							tmp.children = this.filterAsyncRouter(tmp.children, authInfo)
						}
						res.push(tmp)
					}
				})
				return res
			},
			
			checkAuth(router, authInfo) {
				// 判断当前路由在权限数组中是否存在
				if (router.meta) {
					const metaInfo = router.meta
					if (!metaInfo.requiresAuth) {
						return true
					} else {
						if (metaInfo.index == 0) {
							return !!authInfo[metaInfo.type]
						} else if (metaInfo.index == 1) {
							if (authInfo[metaInfo.type]) {
								return !!authInfo[metaInfo.type][metaInfo.subType]
							}
							return false
						} else {
							var typeAuth = authInfo[metaInfo.type]
							for (let index = 0; index < metaInfo.subType.length; index++) {
								const field = metaInfo.subType[index]
								typeAuth = typeAuth[field]
								if (typeAuth && metaInfo.subType.length - 1 == index) {
									return true
								} else if (!typeAuth) {
									return false
								}
							}
						}
					}
				}
				return true
			},
		}
	}
</script>

<style lang="scss" scoped>
	.el-container {
		min-height: 100%;
	}

	.aside-container {
		position: relative;
		background-color: #2d3037;
		box-sizing: border-box;
		border-right: solid 1px #e6e6e6;
	}

	.nav-container {
		padding: 0;
		box-shadow: 0px 1px 2px #dbdbdb;
		z-index: 100;
		min-width: 1200px;
	}
</style>
